module.exports = __webpack_public_path__ + "56ba8cdf5d156ea785dc2ef4fb882613.png";